// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__v9mA+","modalContent":"Modal_modalContent__dOS01"};